// extracted by mini-css-extract-plugin
export var whocontact = "alumni-module--whocontact--1Lf3o";
export var who = "alumni-module--who--BK_eG";